// AppRouter.jsx
import {Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import EventsSearchPage from './pages/EventsSearchPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PrivateRoute from './components/PrivateRoute';
import EventDetailPage from './pages/EventDetailPage';
import EventGalleryPage from './pages/EventGalleryPage';
import MyEventMemoriesPage from './pages/MyEventMemoriesPage';
import OrganizerEventGalleryAdminPage from './pages/OrganizerEventGalleryAdminPage';
import EventCheckinPage from './pages/EventCheckinPage';
import OrganizerRegisterPage from './pages/OrganizerRegisterPage';
import CreateEventPage from './pages/CreateEventPage';
import EventEditPage from './pages/EventEditPage';
import EmailVerifiedSuccess from './pages/EmailVerifiedSuccess';
import EmailVerificationNotice from './pages/EmailVerificationNotice';
import NotFoundPage from './pages/NotFoundPage';
import PurchaseSuccess from './pages/PurchaseSuccess';
import PurchaseCancel from './pages/PurchaseCancel';
import ApplicationConfirmPage from './pages/ApplicationConfirmPage';
import ProfilePage from './components/profile/ProfilePage';
import EditProfile from './components/profile/EditProfile';
import MyProfilePage from './components/profile/MyProfilePage';
import SellerRoute from './components/SellerRoute';
import DashboardPage from './pages/DashboardPage';
import EventSalesPage from './pages/EventSalesPage';
import SellerKycGuidePage from './pages/SellerKycGuidePage';
import EventCancelledPage from './pages/EventCancelledPage';
import CredentialsSettingsPage from './pages/CredentialsSettingsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import SpecifiedCommercialTransactionsPage from './pages/SpecifiedCommercialTransactionsPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import TermsReagreementPage from './pages/TermsReagreementPage';
import LandingPage from './pages/LandingPage';

const AppRouter = () => {
  return (
    <Routes>
      <Route element={<ErrorBoundary><Layout /></ErrorBoundary>}>
        <Route path="/" element={<HomePage />} />
        <Route path="/organizer" element={<LandingPage />} />
        <Route path="/events" element={<EventsSearchPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/terms/reagreement" element={<PrivateRoute><TermsReagreementPage /></PrivateRoute>} />
        <Route path="/legal/specified-commercial-transactions" element={<SpecifiedCommercialTransactionsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/email-verification-notice" element={<EmailVerificationNotice />} />
        <Route path="/email-verified-success" element={<EmailVerifiedSuccess />} />
        <Route path="/events/:id" element={<EventDetailPage />} />
        <Route path="/events/:id/cancelled" element={<EventCancelledPage />} />
        <Route path="/events/:id/gallery" element={<EventGalleryPage />} />
        <Route path="/events/:id/checkin" element={<PrivateRoute><EventCheckinPage /></PrivateRoute>} />
        <Route path="/events/:id/memories" element={<PrivateRoute><MyEventMemoriesPage /></PrivateRoute>} />
        <Route path="/gallery-admin" element={<PrivateRoute><OrganizerEventGalleryAdminPage /></PrivateRoute>} />
        <Route path="/events/:id/gallery-admin" element={<PrivateRoute><OrganizerEventGalleryAdminPage /></PrivateRoute>} />
        <Route path="/seller-register" element={<OrganizerRegisterPage />} />
        <Route path="/seller-kyc-guide" element={<SellerKycGuidePage />} />
        <Route path="/purchase-success" element={<PurchaseSuccess />} />
        <Route path="/purchase-cancel" element={<PurchaseCancel />} />
        <Route
          path="/events/:id/confirm"
          element={
            <PrivateRoute>
              <ApplicationConfirmPage />
            </PrivateRoute>
          }
        />
        <Route path="/profile/:slug" element={<ProfilePage />} />
        <Route
          path="/profile/my"
          element={
            <PrivateRoute>
              <MyProfilePage />
            </PrivateRoute>
          }
        />

        <Route
          path="/events/create"
          element={
            <PrivateRoute>
              <CreateEventPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/events/:id/edit"
          element={
            <PrivateRoute>
              <EventEditPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/events/:id/sales"
          element={
            <PrivateRoute>
              <EventSalesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile/edit"
          element={
            <PrivateRoute>
              <EditProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/credentials"
          element={
            <PrivateRoute>
              <CredentialsSettingsPage />
            </PrivateRoute>
          }
        />
      </Route>
      <Route
        path="/dashboard"
        element={
          <ErrorBoundary>
            <SellerRoute>
              <DashboardPage />
            </SellerRoute>
          </ErrorBoundary>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRouter;
